import { Component, ElementRef, HostListener, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UISyncService } from '../../services/ui-sync.service';
import { AdminAuthService } from '@sgm-frontend/core';
import { SidebarService } from '../../services/sidebar.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  isMenuOpen = false;
  authService = inject(AdminAuthService);

  constructor(
    public uiService: UISyncService,
    public sidebar: SidebarService,
  ) {}

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  logout() {
    this.authService.logOut();
    this.isMenuOpen = false;
  }

  @ViewChild('adminAuthMenu', { static: false }) adminAuthMenu!: ElementRef;

  @HostListener('document:click', ['$event'])
  handleClickOutsideClick(event: MouseEvent): void {
    if (!this.adminAuthMenu) return;
    const clickedInside = this.adminAuthMenu.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isMenuOpen = false;
    }
  }

  openSidebar(): void {
    this.sidebar.autoToggle();
  }
}
